module.exports = __webpack_public_path__ + "img/8a7a021.png";